import PedagogicalApproachAreaController from './pedagogicalApproachAreaController';
import './pedagogicalApproach.scss';

const PedagogicalApproachAreaComponent = {
    template: require('./pedagogicalApproachAreaView.html'),
    controller: PedagogicalApproachAreaController,
};

export default PedagogicalApproachAreaComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/pages/pedagogicalApproachAreaComponent.js